"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralSettings = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./PaymentsSettings.css"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var usePaymentSettings_1 = require("./usePaymentSettings");
var GeneralSettings = function () {
    var _a;
    var _b = (0, usePaymentSettings_1.usePaymentSettings)(), settings = _b.settings, updater = _b.updater;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: styles.settingsCard },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l" },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween" },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", align: "center" },
                    react_1.default.createElement("div", { className: styles.generalSettingsIconStyle },
                        react_1.default.createElement(icons_1.Menu, { style: (0, dynamic_1.assignInlineVars)((_a = {},
                                _a[kaleidoscope_1.iconVars.color] = tokens_1.palette.blue500,
                                _a)) })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, "Default options"),
                        react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs" }, "Choose the default view for payments.")))),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", justify: "center" },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.settingsRow({ hasDivider: true }), direction: "horizontal", align: "center", justify: "spaceBetween", gap: "l" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "s" }, "Require payment on accept"),
                        react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "xs", secondary: true }, "Turn it off if you want buyers to pay when the page is accepted or later.")),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "end" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(kaleidoscope_1.Toggle, { labelHidden: true, disabled: false, key: "key", label: "label", value: settings.requireOnAccept, onChange: function (val) { return updater({ requireOnAccept: val }); } }))))),
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.settingsRow({ hasDivider: false }), direction: "horizontal", align: "center", justify: "spaceBetween", gap: "l" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "s" }, "Part payments"),
                        react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "xs", secondary: true }, "Buyers can pay a percentage or partial amount when page is accepted.")),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "end" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(kaleidoscope_1.Toggle, { labelHidden: true, disabled: false, key: "key", label: "label", value: settings.enablePartPayments, onChange: function (val) { return updater({ enablePartPayments: val }); } })))))))));
};
exports.GeneralSettings = GeneralSettings;
